export default __webpack_public_path__ + "static/media/atarud.aa8d9bf8.jpg";